module.exports = __webpack_public_path__ + "static/media/sentIcon.9de9cb41.svg";